/**
 * Kadr w wersji językowej. Grafiki EN mają w API osobne property (mediaEn) i thumby
 * z sufiksem _en - gdy admin nie wgrał wersji angielskiej, wracamy na wersję PL.
 */
export const getLocalizedThumb = (entity, name, locale) => {
  const thumbs = entity?.thumbs || {}

  if (locale === 'en') {
    return thumbs[`${name}_en`] || thumbs[name] || null
  }

  return thumbs[name] || null
}

export const getLocalizedThumbName = (name, locale) => (locale === 'en' ? `${name}_en` : name)

/** Oryginał grafiki (nie kadr) w wersji językowej - z fallbackiem na PL. */
export const getLocalizedMedia = (entity, locale) =>
  (locale === 'en' ? entity?.mediaEn || entity?.media : entity?.media) || null
